import React from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { IMediaType } from '../../types/mediaType'
import { updateMediaType } from '../../actions/mediaType'
import { push } from '../../actions/router'
import { mediaTypeValidationSchema } from '../MediaTypeForm/validation'
import { NavigationGuard } from '../../components'
import MediaTypeForm from '../MediaTypeForm'

interface IUpdateMediaTypeForm {
  mediaType: IMediaType
  editable: boolean
  dispatch: Dispatch
}

export const UpdateMediaTypeForm = ({
  mediaType,
  editable,
  dispatch,
}: IUpdateMediaTypeForm) => (
  <Formik
    key={mediaType.modified}
    initialValues={mediaType}
    onSubmit={(values) => {
      dispatch(updateMediaType(values))
    }}
    render={(formikProps) => (
      <>
        <MediaTypeForm
          formikProps={formikProps}
          editable={editable}
          submitText="Save"
          disableExtension
          cancelAction={() => {
            formikProps.resetForm()
            dispatch(push('/settings/media-types?tab=all-types'))
          }}
        />
        <NavigationGuard isBlocking={formikProps.dirty} />
      </>
    )}
    validationSchema={mediaTypeValidationSchema}
  />
)
